import { create } from 'zustand';

type SelectionExportStoreState = {
  isExporting: boolean;
  loadedFiles: number;
  totalFiles: number;
  controller: AbortController | null;
  beginExport: (controller: AbortController) => void;
  setProgress: (loadedFiles: number, totalFiles: number) => void;
  endExport: () => void;
  cancelExport: () => void;
};

export const useSelectionExportStore = create<SelectionExportStoreState>((set, get) => ({
  isExporting: false,
  loadedFiles: 0,
  totalFiles: 0,
  controller: null,

  beginExport: (controller) => set({
    isExporting: true,
    loadedFiles: 0,
    totalFiles: 0,
    controller,
  }),

  setProgress: (loadedFiles, totalFiles) => set({ loadedFiles, totalFiles }),

  endExport: () => set({
    isExporting: false,
    loadedFiles: 0,
    totalFiles: 0,
    controller: null,
  }),

  cancelExport: () => {
    const { controller } = get();
    controller?.abort();
    set({
      isExporting: false,
      loadedFiles: 0,
      totalFiles: 0,
      controller: null,
    });
  },
}));
